/**
 * Map Configuration Constants
 */

// Dubai coordinates (default location)
export const DUBAI_COORDINATES = {
  lat: 25.276987,
  lng: 55.296249,
};

// Default map settings
export const DEFAULT_MAP_CONFIG = {
  center: [DUBAI_COORDINATES.lat, DUBAI_COORDINATES.lng],
  zoom: 12,
  minZoom: 3,
  maxZoom: 18,
};

// Map tile layer URLs
export const MAP_TILE_LAYERS = {
  openstreetmap: {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  },
  // Can add more tile providers later (Mapbox, etc.)
};






